import { render, staticRenderFns } from "./SPUAudit.vue?vue&type=template&id=6df27948&scoped=true"
import script from "./SPUAudit.vue?vue&type=script&lang=ts"
export * from "./SPUAudit.vue?vue&type=script&lang=ts"
import style0 from "./SPUAudit.vue?vue&type=style&index=0&id=6df27948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df27948",
  null
  
)

export default component.exports